var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapDrawerMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 70,
    viewBox: "0 0 68 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: -10,
    y: -10,
    width: 88,
    height: 90
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(5px)",
      clipPath: "url(#bgblur_0_21470_5341_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 10
  }, /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 70,
    rx: 12,
    fill: "black",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.9996 32L42.3196 26.27L44.1735 25L33.9996 18L23.8257 25L25.6683 26.27L33.9996 32ZM33.9883 34.54L25.657 28.81L23.8257 30.07L33.9996 37.07L44.1735 30.07L42.3309 28.8L33.9883 34.54ZM40.488 25.0012L33.9993 20.5312L27.5106 25.0012L33.9993 29.4712L40.488 25.0012Z",
    fill: "#696F88"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.7393,
    y: 12,
    width: 4.52174,
    height: 2,
    rx: 1,
    fill: "#868CA2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.9998 49.1667C30.7798 49.1667 28.1665 51.7801 28.1665 55.0001C28.1665 58.2201 30.7798 60.8334 33.9998 60.8334C37.2198 60.8334 39.8332 58.2201 39.8332 55.0001C39.8332 51.7801 37.2198 49.1667 33.9998 49.1667ZM33.4165 52.0834V53.2501H34.5832V52.0834H33.4165ZM33.4165 54.4167V57.9167H34.5832V54.4167H33.4165ZM29.3332 55.0001C29.3332 57.5726 31.4273 59.6667 33.9998 59.6667C36.5723 59.6667 38.6665 57.5726 38.6665 55.0001C38.6665 52.4276 36.5723 50.3334 33.9998 50.3334C31.4273 50.3334 29.3332 52.4276 29.3332 55.0001Z",
    fill: "#696F88"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_21470_5341_clip_path",
    transform: "translate(10 10)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 70,
    rx: 12
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapDrawerMenu);
export default __webpack_public_path__ + "static/media/map-drawer-menu.09298ea6daff439ad4025889815d4a0d.svg";
export { ForwardRef as ReactComponent };